import { useState } from "react";
import { toast } from "sonner";
import { Globe } from "lucide-react";
import api, { errorMessage } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { deviceZoneSuggestion, userZone, zoneLabel, zoneName } from "../lib/time";

const KEY = "jamora.tz.declined";

const declined = (zone) => { try { return window.localStorage.getItem(KEY) === zone; } catch { return false; } };

// Sous l'en-tête quand l'appareil dit un autre fuseau que celui qu'utilise la personne (proposition D-TZ-4). Une SUGGESTION : rien n'est changé sans
// un clic, et un refus est mémorisé pour ce fuseau-là sur cet appareil (un déplacement ou un poste mal réglé ne doit pas changer des heures en silence).
export default function TimezoneNotice() {
  const { user, updateUser } = useAuth();
  const [gone, setGone] = useState(false);
  const [saving, setSaving] = useState(false);
  const device = user ? deviceZoneSuggestion(user) : null;
  if (!device || gone || declined(device)) return null;

  const accept = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/timezone", { timezone: device });
      updateUser(data);
      toast.success(`Vos heures sont désormais en heure de ${zoneLabel(device)}`);
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setSaving(false);
    }
  };
  const decline = () => { try { window.localStorage.setItem(KEY, device); } catch { /* storage unavailable: the notice just goes away for this visit */ } setGone(true); };

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-sky-200 bg-sky-50 px-4 py-2 text-sm text-sky-900" role="status" data-testid="timezone-notice">
      <Globe size={16} className="shrink-0" aria-hidden />
      <span className="min-w-0 basis-[calc(100%-2rem)] sm:basis-0 sm:flex-1">Votre appareil est en heure de {zoneLabel(device)} ; vos heures sont lues en heure de {zoneName(userZone(user))}.</span>
      <div className="flex gap-2">
        <Button size="sm" onClick={accept} disabled={saving} data-testid="timezone-notice-accept">Utiliser {zoneName(device)}</Button>
        <Button size="sm" variant="outline" onClick={decline} data-testid="timezone-notice-decline">Non merci</Button>
      </div>
    </div>
  );
}
